import { React, useRef, useState, useEffect } from "react";

import Footer2 from "./Footer2";
import HeaderLower from "./HeaderLower";
import "./style.css";
import "bootstrap/dist/css/bootstrap.min.css";
import secureLocalStorage from "react-secure-storage";

import RegisterService from "../services/register.service";

import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";

import Swal from "sweetalert2";

import Select from "react-select";

function RegisterForm(props) {
  const TITLE = process.env.REACT_APP_API_SITE_TITLE + " | Registration Form";
  const [fields, setFields] = useState({
    name: "",
    lname: "",
    phone: "",
    emailid: "",
    store_location: "",
    sales_name_f: "",
    sales_name_l: "",
  });

  const [errors, setErrors] = useState({});

  const [storeId, setStoreId] = useState([]);
  const [emailCheck, setEmailCheck] = useState(false);

  const [signoutTime, setSignoutTime] = useState(900000);
  const [value_userform, setValue_userform] = useState([]);

  const navigate = useNavigate();

  secureLocalStorage.removeItem("registerform");

  useEffect(() => {
    async function getStoreLocation() {
      let errors = {};

      try {
        //FIXME remove this service if not used
        const response = await RegisterService.getStoreLocation();
        let value = response.data.data;
        const results = [];
        value.map((value) => {
          return results.push({
            value: value.store_location,
            label: value.store_location,
          });
        });
        await setStoreId([...results]);

        if (response.data.status === 429 || response.data.status === "429") {
          alert("Max Limit Reached. Please wait.");
        }
        if (value.includes("redirect")) {
        } else {
          errors["questionnare"] = response.data.response;
        }
      } catch (err) {
        if (err.status === 429 || err.status === "429") {
          alert("Max Limit Reached. Please wait.");
        }
      }
    }

    getStoreLocation();
  }, []);

  timeout();
  function timeout() {
    setTimeout(function () {
      logout();
    }, signoutTime);
  }

  const logout = () => {
    destroy();
  };

  const destroy = () => {
    localStorage.setItem("returnpage", true);
    localStorage.removeItem("return_page");
    localStorage.removeItem("registerForm");
    localStorage.removeItem("isRegister");
  };

  const ref = useRef();

  const handleChange = (e) => {
    let { value, name } = e.target;
    if (name === "state" && value === "true") {
      value = "";
    }
    if (name === "store_location" && value === "true") {
      value = "";
    }

    setFields((prevValue) => {
      return {
        ...prevValue,
        [name]: value,
      };
    });
  };
  const saveErrors = (err) => {
    setErrors(err);
  };

  const submituserRegistrationForm = (e) => {
    e.preventDefault();
    if (validate()) {
      let data = {
        fname: fields?.name,
        lname: fields?.lname,
        phone: fields?.phone,
        email: fields?.emailid,
        store_location: fields?.store_location,
        sales_name_f: fields?.sales_name_f,
        sales_name_l: fields?.sales_name_l,
      };

      try {
        const responseuserform = RegisterService.regData(data);
        responseuserform
          .then((response) => {
            var valueUserform = response?.data?.status;
            setValue_userform(valueUserform);

            Swal.fire({
              title: "Successful!",
              text: "Form Submitted!",
              type: "success",
              icon: "success",
            }).then((result) => {
              secureLocalStorage.setItem(
                "registerform",
                JSON.stringify({
                  name: fields.name,
                  lname: fields.lname,
                  phone: fields.phone,
                  emailid: fields.emailid,
                  store_location: fields.store_location,
                  sales_name_f: fields.sales_name_f,
                  sales_name_l: fields.sales_name_l,
                })
              );
              localStorage.removeItem("return_page");
              localStorage.setItem("isRegister", true);
              navigate("/register/registration-thankyou");
            });

            if (value_userform?.includes("redirect")) {
            }
          })
          .catch((err) => {
            if (
              err?.response?.data?.message &&
              typeof err?.response?.data?.message === "string"
            ) {
              Swal.fire({
                title: "Error!",
                text: err?.response?.data?.message,
                type: "error",
                icon: "error",
              });
            }
            let errorData = {};
            errorData["name"] =
              err?.response?.data?.message &&
              err?.response?.data?.message.fname &&
              err?.response?.data?.message.fname[0];
            errorData["lname"] =
              err?.response?.data?.message &&
              err?.response?.data?.message.lname &&
              err?.response?.data?.message.lname[0];
            errorData["phone"] =
              err?.response?.data?.message &&
              err?.response?.data?.message.phone &&
              err?.response?.data?.message.phone[0];
            errorData["emailid"] =
              err?.response?.data?.message &&
              err?.response?.data?.message.email &&
              err?.response?.data?.message.email[0];
            errorData["store_location"] =
              err?.response?.data?.message &&
              err?.response?.data?.message.store_location &&
              err?.response?.data?.message.store_location[0];
            errorData["sales_name_f"] =
              err?.response?.data?.message &&
              err?.response?.data?.message.sales_name_f &&
              err?.response?.data?.message.sales_name_f[0];
            errorData["sales_name_l"] =
              err?.response?.data?.message &&
              err?.response?.data?.message.sales_name_l &&
              err?.response?.data?.message.sales_name_l[0];
            errorData["checkederrortwo"] =
              err?.response?.data?.message &&
              err?.response?.data?.message.size &&
              err?.response?.data?.message.size[0];
            saveErrors(errorData);
            ref?.current?.focus();
          });
      } catch (err) {
        alert(err);
        if (err.response.status === 429 || err.response.status === "429") {
          alert("Max Limit Reached. Please wait.");
        }
        let errorData = {};
        errorData["name"] = err?.response?.data?.message.fname[0];
        errorData["lname"] = err?.response?.data?.message.lname[0];
        errorData["phone"] = err?.response?.data?.message.phone[0];
        errorData["emailid"] = err?.response?.data?.message.emailid[0];
        errorData["store_location"] =
          err?.response?.data?.message.store_location[0];
        errorData["sales_name_f"] =
          err?.response?.data?.message.sales_name_f[0];
        errorData["sales_name_l"] =
          err?.response?.data?.message.sales_name_l[0];
        saveErrors(errorData);
      }
    }
  };
  const validate = (e) => {
    let isformIsValid = true;

    return isformIsValid;
  };

  const pasted = (e) => {
    e.preventDefault();
    return false;
  };

  const onlyNumbers = (evt) => {
    const { name, value } = evt.target;
    evt.target.value = evt.target.value.replace(/[^0-9]+/g, "");

    setFields((prevValue) => {
      return {
        ...prevValue,
        [name]: evt.target.value,
      };
    });
  };

  const emailExist = async (email) => {
    setEmailCheck(false);
    try {
      if (email != "") {
        await RegisterService.emailExist(email);
        setEmailCheck(false);
      }
    } catch (error) {
      if (error.response.status === 409) {
        setEmailCheck(true);
      }
    }
  };

  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>

      <div className="container-fluid">
        {/* <HeaderInner/> */}
        <HeaderLower />
        <div id="main-registration-container">
          <div className="white-box form" id="font-style">
            <h1>Register your guest for their $25 Mastercard Reward Card!</h1>
            <hr />
            <form
              name="userRegistrationForm"
              className="form-outer"
              onSubmit={submituserRegistrationForm}
              // onClick={this.popup}
            >
              <div className="row">
                <div className="col-md-6">
                  <label className="formsub">
                    Customer First Name <span className="red_point">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Customer First Name"
                    style={errors.name ? { border: "1px solid red" } : null}
                    name="name"
                    id="fname"
                    className="searchBox_deals vc-validate"
                    ref={errors.name ? ref : null}
                    value={fields.name || ""}
                    autoFocus=""
                    onChange={handleChange}
                  />
                  <div className="errorMsg">{errors.name}</div>
                </div>
                <div className="col-md-6">
                  <label className="formsub">
                    Customer Last Name <span className="red_point">*</span>
                  </label>
                  <input
                    type="text"
                    name="lname"
                    style={
                      errors.lname && !errors.name
                        ? { border: "1px solid red" }
                        : null
                    }
                    placeholder="Customer Last Name"
                    id="lname"
                    className="searchBox_deals vc-validate"
                    value={fields.lname || ""}
                    ref={errors.lname && !errors.name ? ref : null}
                    onChange={handleChange}
                  />
                  <div className="errorMsg">
                    {errors.lname && !errors.name ? errors.lname : null}
                  </div>
                </div>
                <div className="col-md-6">
                  <label className="formsub">
                    Customer Phone Number <span className="red_point">*</span>
                  </label>
                  <input
                    type="text"
                    name="phone"
                    style={
                      errors.phone && !errors.lname && !errors.name
                        ? { border: "1px solid red" }
                        : null
                    }
                    placeholder="Customer Phone Number"
                    id="phone"
                    className="searchBox_deals vc-validate"
                    value={fields.phone || ""}
                    ref={
                      errors.phone && !errors.lname && !errors.name ? ref : null
                    }
                    onChange={handleChange}
                    onKeyUp={onlyNumbers}
                    onPaste={pasted}
                  />
                  <div className="errorMsg">
                    {errors.phone && !errors.lname && !errors.name
                      ? errors.phone
                      : null}
                  </div>
                </div>

                <div className="col-md-6">
                  <label className="formsub">
                    Customer Email Address <span className="red_point">*</span>
                  </label>
                  <input
                    type="text"
                    name="emailid"
                    ref={
                      errors.emailid &&
                      !errors.phone &&
                      !errors.lname &&
                      !errors.name
                        ? ref
                        : null
                    }
                    style={
                      errors.emailid &&
                      !errors.phone &&
                      !errors.lname &&
                      !errors.name
                        ? { border: "1px solid red" }
                        : null
                    }
                    id="emailid"
                    placeholder="Customer Email Address"
                    value={fields.emailid || ""}
                    autoFocus=""
                    onChange={(e) => {
                      handleChange(e);
                      emailExist(e.target.value);
                    }}
                  />
                  <div className="errorMsg">
                    {errors.emailid &&
                    !emailCheck &&
                    !errors.phone &&
                    !errors.lname &&
                    !errors.name
                      ? errors.emailid
                      : null}
                    {emailCheck && "Email already exists."}
                  </div>
                </div>

                <div className="col-md-6">
                  <label className="formsub">
                    Store Location<span className="red_point"> *</span>
                  </label>
                  <Select
                    classNamePrefix="react-select"
                    className={`select_1 dropdown ${
                      errors.store_location &&
                      !errors.emailid &&
                      !errors.phone &&
                      !errors.lname &&
                      !errors.name
                        ? "error-select-search"
                        : ""
                    }`}
                    placeholder="Select Store Location"
                    options={storeId}
                    isSearchable={true}
                    isClearable={true}
                    name="store_location"
                    ref={
                      errors.store_location &&
                      !errors.emailid &&
                      !errors.phone &&
                      !errors.lname &&
                      !errors.name
                        ? ref
                        : null
                    }
                    onChange={(selectedOption) => {
                      if (selectedOption) {
                        setFields((prevValue) => {
                          return {
                            ...prevValue,
                            ["store_location"]: selectedOption.value,
                          };
                        });
                      } else {
                        setFields((prevValue) => {
                          return {
                            ...prevValue,
                            ["store_location"]: "",
                          };
                        });
                      }
                    }}
                  />
                  {/* <select
                    style={
                      errors.store_location &&
                      !errors.emailid &&
                      !errors.phone &&
                      !errors.lname &&
                      !errors.name
                        ? { border: "1px solid red", color: "black" }
                        : { color: "black" }
                    }
                    ref={
                      errors.store_location &&
                      !errors.emailid &&
                      !errors.phone &&
                      !errors.lname &&
                      !errors.name
                        ? ref
                        : null
                    }
                    name="store_location"
                    id="store_location"
                    className="select_1 dropdown"
                    autoFocus=""
                    onChange={handleChange}
                  >
                    <option value>Select Store Location</option>
                    <option value="Bluffton, SC">Bluffton, SC</option>
                    <option value="Florence, SC">Florence, SC</option>
                    <option value="Goldsboro, NC">Goldsboro, NC</option>
                    <option value="Greenville, NC">Greenville, NC</option>
                    <option value="Greenville Outlet, NC">
                      Greenville Outlet, NC
                    </option>
                    <option value="Jacksonville, NC">Jacksonville, NC</option>
                    <option value="Morehead City, NC">Morehead City, NC</option>
                    <option value="Mt. Pleasant, SC">Mt. Pleasant, SC</option>
                    <option value="Myrtle Beach, SC">Myrtle Beach, SC</option>
                    <option value="New Bern, NC">New Bern, NC</option>
                    <option value="North Charleston, SC">
                      North Charleston, SC
                    </option>
                    <option value="Parrott’s Furniture">
                      Parrott’s Furniture
                    </option>
                    <option value="Savannah, GA">Savannah, GA</option>
                    <option value="Shallotte, NC">Shallotte, NC</option>
                  </select> */}
                  <div className="errorMsg">
                    {errors.store_location &&
                    !errors.emailid &&
                    !errors.phone &&
                    !errors.lname &&
                    !errors.name
                      ? errors.store_location
                      : null}
                  </div>
                </div>
                <div className="col-md-6">
                  <label className="formsub">
                    Employee First Name <span className="red_point">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Employee First Name"
                    style={
                      errors.sales_name_f &&
                      !errors.store_location &&
                      !errors.emailid &&
                      !errors.phone &&
                      !errors.lname &&
                      !errors.name
                        ? { border: "1px solid red" }
                        : null
                    }
                    name="sales_name_f"
                    id="sales_name_f"
                    className="searchBox_deals vc-validate"
                    ref={
                      errors.sales_name_f &&
                      !errors.store_location &&
                      !errors.emailid &&
                      !errors.phone &&
                      !errors.lname &&
                      !errors.name
                        ? ref
                        : null
                    }
                    value={fields.sales_name_f || ""}
                    onChange={handleChange}
                  />
                  <div className="errorMsg">
                    {errors.sales_name_f &&
                    !errors.store_location &&
                    !errors.emailid &&
                    !errors.phone &&
                    !errors.lname &&
                    !errors.name
                      ? errors.sales_name_f
                      : null}
                  </div>
                </div>

                <div className="col-md-6">
                  <label className="formsub">
                    Employee Last Name <span className="red_point">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Employee Last Name"
                    style={
                      errors.sales_name_l &&
                      !errors.sales_name_f &&
                      !errors.store_location &&
                      !errors.emailid &&
                      !errors.phone &&
                      !errors.lname &&
                      !errors.name
                        ? { border: "1px solid red" }
                        : null
                    }
                    name="sales_name_l"
                    id="sales_name_l"
                    className="searchBox_deals vc-validate"
                    ref={
                      errors.sales_name_l &&
                      !errors.sales_name_f &&
                      !errors.store_location &&
                      !errors.emailid &&
                      !errors.phone &&
                      !errors.lname &&
                      !errors.name
                        ? ref
                        : null
                    }
                    value={fields.sales_name_l || ""}
                    onChange={handleChange}
                  />
                  <div className="errorMsg">
                    {errors.sales_name_l &&
                    !errors.sales_name_f &&
                    !errors.store_location &&
                    !errors.emailid &&
                    !errors.phone &&
                    !errors.lname &&
                    !errors.name
                      ? errors.sales_name_l
                      : null}
                  </div>
                </div>

                <br />

                <div className="clearfix"></div>
              </div>

              <div className="alert alert-info">
                Limit 1 per household, while supplies last. Some restrictions
                apply, see store for detail.
              </div>
              <input
                disabled={emailCheck}
                type="submit"
                name="submit"
                id="submit"
                value="SUBMIT"
                className="sub-btn2 button Formfirst"
              />
            </form>
          </div>
        </div>
      </div>
      <Footer2 />
    </>
  );
}
export default RegisterForm;
